<template>
  <div class="settings-container" v-if="props.data">

    <div class="section-header">
      <h3>Storefront appearance</h3>
      <!-- <el-select v-if="props.canEdit" v-model="props.data.storefrontAppearance.permission" default-first-option @change="handleStorefrontChange">
          <el-option v-for="item in props.data.storefrontAppearance.permissionOption" :key="item.type" :label="item.name"
            :value="item.type" />
      </el-select>
      <span v-else>Can access</span> -->
    </div>

    <div class="setting-item" v-if="props.data.editStorefrontAppearance">
      <span>Edit storefront appearance</span>
      <div>
        <Switch v-if="props.canEdit" :checked="props.data.editStorefrontAppearance.permission === 100"
        @click.native="switchItem(props.data, 'editStorefrontAppearance.permission')" />
        <span v-else>{{ switchText(props.data.editStorefrontAppearance.permission) }}</span>
      </div>
    </div>

    <div class="setting-item" v-if="props.data.editCreatorStorefrontPermissions">
      <span>Edit creator Permissions</span>
      <div>
        <Switch v-if="props.canEdit" :checked="props.data.editCreatorStorefrontPermissions.permission === 100"
        @click.native="switchItem(props.data, 'editCreatorStorefrontPermissions.permission')" />
        <span v-else>{{ switchText(props.data.editCreatorStorefrontPermissions.permission) }}</span>
      </div>
    </div>

<!-- 
    <div class="section-header section-header-2" v-if="props.data.contentSettings">
      <h3>Content settings</h3>
      <el-select v-if="props.canEdit" v-model="props.data.contentSettings.permission" default-first-option @change="handleContentChange">
          <el-option v-for="item in props.data.contentSettings.permissionOption" :key="item.type" :label="item.name"
            :value="item.type" />
        </el-select>
      <span v-else>Can access</span>
    </div> -->

    <div class="setting-item" v-if="props.data.editTrackedHashtagsAndSocialMentions">
      <span>Edit tracked hashtags and social mentions</span>
      <div>
        <Switch v-if="props.canEdit" :checked="props.data.editTrackedHashtagsAndSocialMentions.permission === 100"
        @click.native="switchItem(props.data, 'editTrackedHashtagsAndSocialMentions.permission')" />
        <span v-else>{{ switchText(props.data.editTrackedHashtagsAndSocialMentions.permission) }}</span>
      </div>
    </div>

    <div class="setting-item" v-if="props.data.editContentTag">
      <span>Edit content tags</span>
      <div>
        <Switch v-if="props.canEdit" :checked="props.data.editContentTag.permission === 100"
        @click.native="switchItem(props.data, 'editContentTag.permission')" />
        <span v-else>{{ switchText(props.data.editContentTag.permission) }}</span>
      </div>
    </div>

    <!-- not start -->
    <!-- <div class="section-header section-header-2">
      <h3>Creator tag</h3>
      <el-select v-model="props.data.contentSettings.permission" default-first-option @change="handleContentChange">
          <el-option v-for="item in props.data.contentSettings.permissionOption" :key="item.type" :label="item.name"
            :value="item.type" />
        </el-select>
        <span v-else>{{ switchParentText(props.data.contentSettings.permission) }}</span>
      </div>

    <div class="setting-item indented">
      <span>Create/edit creator tag</span>
      <div v-if="props.data.manageMessaging.permission === 100">
      <Switch v-if="props.canEdit" :checked="props.data.editTrackedHashtagsAndSocialMentions.permission === 100"
      @click.native="switchItem(props.data, 'editTrackedHashtagsAndSocialMentions.permission')" />
      <span v-else>{{ switchText(props.data.editTrackedHashtagsAndSocialMentions.permission) }}</span>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import Switch from '@/components/ui/Switch.vue';
import { ElSelect, ElOption } from 'element-plus';
import { useTeamFunction } from './teamFunction';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  isOwner: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  }
});

const { switchItem,switchText,switchParentText } = useTeamFunction();
//+++++++++++++++++++++++++++++
const handleStorefrontChange = (event) => {
  props.data.editStorefrontAppearance.permission = event;
  props.data.editCreatorStorefrontPermissions.permission = event;
};
const handleContentChange = (event) => {
  props.data.editTrackedHashtagsAndSocialMentions.permission = event;
  props.data.editContentTag.permission = event;
};

const handleCreatorTagChange=(event)=>{

}

</script>
